import _defineProperty from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _BLOCK_SIMPLE_COLORS_;
import { BlockSimpleColor } from '@vtblife/block-kit-types';
export var BLOCK_SIMPLE_COLORS_MAP = {
  gray: 'hsl(230, 50%, 98%)',
  blue: 'hsl(238, 70%, 39%)',
  white: '#FFFFFF'
};
export var BLOCK_SIMPLE_COLORS_NEGATIVE_MAP = (_BLOCK_SIMPLE_COLORS_ = {}, _defineProperty(_BLOCK_SIMPLE_COLORS_, BlockSimpleColor.White, BlockSimpleColor.Gray), _defineProperty(_BLOCK_SIMPLE_COLORS_, BlockSimpleColor.Blue, BlockSimpleColor.White), _defineProperty(_BLOCK_SIMPLE_COLORS_, BlockSimpleColor.Gray, BlockSimpleColor.White), _BLOCK_SIMPLE_COLORS_);